var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-message",attrs:{"data-cy":"error-message"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }